// extracted by mini-css-extract-plugin
module.exports = {"contact":"kontakt_contact__eMKic"};